import StoryDefaultTemplate from '@/components/main/MyPlus/common/TemplateType/StoryDefaultTemplate';
import {useEffect, useState} from 'react';
import {VOD_TYPES} from '@/constants';
import {CATEGORY_SLICE_CNT} from '@/constants/main';

const StoryContentType = ({data, hiddenStreamer, onChangeEnabled, log}) => {
  const [itemList, setItemList] = useState([]);

  useEffect(() => {
    if (data) {
      const filteredList = data
        .filter(
          (item) =>
            !hiddenStreamer.includes(item.originalUserId ?? item.userId),
        )
        .slice(0, CATEGORY_SLICE_CNT);

      if (filteredList.length < 10) {
        onChangeEnabled(false);
      } else {
        onChangeEnabled(true);
      }

      const transformedList = filteredList.map((storyItem) => {
        const {
          thumb,
          titleNo,
          resolutionType,
          titleName,
          viewCnt,
          bjId,
          thumbH,
          fileType,
          storyIdx,
          verticalThumb,
          grade,
          category,
          listDataType,
          broadDate,
          ...rest
        } = storyItem;

        const isHorizontal = resolutionType === 'horizontal';

        return {
          ...storyItem,
          catchId:
            fileType === VOD_TYPES.CATCH_STORY ? storyIdx : storyItem.titleNo,
          thumbnailSrc:
            storyItem.fileType === VOD_TYPES.CATCH_STORY
              ? isHorizontal
                ? thumb
                : verticalThumb
              : isHorizontal
                ? thumbH
                : thumb,
          isHorizontal: isHorizontal,
          viewCount: viewCnt || 0,
          title: titleName,
          userId: bjId,
          isAdult: Number(grade) === 19 && Number(category) === 30000,
          isStory: fileType === VOD_TYPES.CATCH_STORY,
          broadcastDate: broadDate,
          listDataType:
            fileType === VOD_TYPES.CATCH_STORY ? 'catchstory' : listDataType,
        };
      });

      setItemList([...transformedList]);
    }
  }, [data, hiddenStreamer]);

  return (
    <>
      <StoryDefaultTemplate itemList={itemList} log={log} />
    </>
  );
};
export default StoryContentType;
